import Vue from 'vue'
import './utilities/eventHub'
import './pollyfills'
import './assets/tailwind.css'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import lodash from 'lodash'
import VueMoment from 'vue-moment'
import moment from 'moment'
import {abilitiesPlugin} from '@casl/vue'
import {AbilityBuilder} from '@casl/ability'
import sidebarLinks from './sidebarLinks'
import VueCookies from 'vue-cookies'
import VueLogger from 'vuejs-logger'
import VCalendar from 'v-calendar'
import {
  assemblePlanNameDisplay,
  formatCommentDate,
  formatCurrency,
  formatDate,
  formatDateTime,
  formatFileSize,
  formatPrintBool,
  formatToCsv,
  onUnload,
  priorityLabel
} from './utilities/utils'
import ScrollTo from 'vue-scrollto'
import Constants from './utilities/constants'
import {store} from './store/store'
import {Auth0Plugin} from './auth/index'
const { VUE_APP_IDENTITY_PROVIDER_DOMAIN, VUE_APP_IDENTITY_PROVIDER_CLIENT_ID } = process.env

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import './assets/tailwind.css'

//toggles unload confirmation
if (process.env.VUE_APP_ENABLE_UNLOAD_WARNING === 'true') {
  addEventListener('beforeunload', onUnload)
}

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(VueCookies)
Vue.use(ScrollTo)
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: process.env.VUE_APP_LOG_LEVEL || Constants.LOG_LEVELS.ERROR,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
})
Vue.use(VCalendar)
Vue.use(abilitiesPlugin, AbilityBuilder.define((can, cannot) => {}))

let router = null
try {
  router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: 'active'
  })
} catch (e) {
  console.error('Failure setting up Vue Router with Auth and Access', JSON.parse(JSON.stringify(e)))
  alert('Failure setting up Vue Router with Auth and Access. Halting PTRAC Admin App. Please try refreshing your browser.')
  throw new Error("Failure setting up Vue Router with Auth and Access.")
}

try {
  Vue.use(Auth0Plugin,{
    domain: VUE_APP_IDENTITY_PROVIDER_DOMAIN,
    clientId: VUE_APP_IDENTITY_PROVIDER_CLIENT_ID,
    redirect_uri: window.location.origin + '/#/login',
    // this method is used even if Webstorm thinks it isn't
    onRedirectCallback: () => {
      window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
      window.location.hash = '#/projects/search'
    },
    $store: store // needed to hydrate security store's user id and groups after receiving a JWT back from Auth0
  })
} catch (e) {
  // this "shouldn't" happen. Hopefully we'll get some useful output if it does
  localStorage.clear()
  console.error('Failure setting up Auth0 and Access Configuration', JSON.parse(JSON.stringify(e)))
  alert('Failure setting up Auth0 and Access Configuration. Halting PTRAC Admin App. Please try refreshing your browser.')
  throw new Error("Failure setting up Auth0 and Access Configuration.")
}

locale.use(lang)

Vue.use(VueMoment, {
  moment
})

Vue.filter('formatDate', (value) => {
  return formatDate(value)
})

Vue.filter('formatDateTime', (value) => {
  return formatDateTime(value)
})

Vue.filter('formatCommentDate', (value) => {
  return formatCommentDate(value)
})

Vue.filter('fileSize', (bytes) => {
  return formatFileSize(bytes)
})

Vue.filter('toCsv', (data) => {
  return formatToCsv(data)
})

Vue.filter('printBool', (value) => {
  return formatPrintBool(value)
})

Vue.filter('formatPrice', (value) => {
  return formatCurrency(value)
})

Vue.filter('priorityLabel', (value) => {
  return priorityLabel(value)
})

Vue.filter('planName', (value) => {
  return assemblePlanNameDisplay(value)
})

Vue.filter('nl2br', (value) => {
  return nl2br(value)
})

store.$eventHub = Vue.prototype.$eventHub

Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router
})

const falsy = /^(?:f(?:alse)?|no?|0+)$/i
Boolean.parse = val => {
  return !falsy.test(val) && !!val
}
